<script lang="ts" setup>
const { t } = useI18n()

const buttons = [
  {
    name: 'apple',
    label: t('app-store'),
    aria: 'Belong in AppStore',
    icon: 'mdi:apple',
    to: '/install?p=ios',
  },
  {
    name: 'google',
    label: t('google-play-0'),
    aria: 'Belong in Google Play',
    icon: 'mdi:google-play',
    to: '/install?p=android',
  },
]
</script>

<template>
  <div class="flex flex-wrap justify-center gap-4">
    <NuxtLink
      v-for="btn in buttons"
      :key="btn.name"
      :to="btn.to"
      target="_blank"
      :aria-label="btn.aria"
    >
      <div
        class="p-0.25 rounded-full overflow-hidden common-gradient before:bg-gradient-to-r before:from-[#7540ee] before:via-[#4467ff] before:to-[#ff8fe9] before:rounded-full relative"
      >
        <div
          class="bg-[#00000033] rounded-full flex flex-row items-center gap-2 py-2.5 px-3.5"
        >
          <Icon :name="btn.icon" class="w-5 h-5" />
          <p class="uppercase font-medium text-sm tracking-wide">
            {{ btn.label }}
          </p>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
